import { OwnMoneyQuestion } from '@hb/domain';
import { OwnMoneyPartStoreService } from '@hb/modules/extra-asset/own-money-part/own-money-part-store.service';
import { PreviousButtonComponent } from '@hb/modules';
import { OwnMoneyGlobalComponent } from '@hb/modules/extra-asset/own-money-part/own-money-amount/own-money-amount.component';
import { OwnMoneyComponent } from '@hb/modules/extra-asset/own-money-part/own-money/own-money.component';

import { Subscription } from 'rxjs';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApContentModule } from '@ap/content';

@Component({
    selector: 'own-money-part',
    templateUrl: './own-money-part.component.html',
    standalone: true,
    imports: [ApContentModule, ReactiveFormsModule, PreviousButtonComponent, OwnMoneyGlobalComponent, OwnMoneyComponent]
})
export class OwnMoneyPartComponent implements OnInit, OnDestroy {
    protected readonly store = inject(OwnMoneyPartStoreService);

    protected activeQuestion: OwnMoneyQuestion;
    private activeQuestionSubscription: Subscription;

    ngOnInit(): void {
        this.activeQuestionSubscription = this.store
            .getActiveQuestion()
            .subscribe((activeQuestion) => (this.activeQuestion = activeQuestion));
    }

    ngOnDestroy(): void {
        this.activeQuestionSubscription.unsubscribe();
    }

    previousQuestion(): void {
        this.store.backQuestion();
    }

    showOwnMoney(): boolean {
        return (
            (this.activeQuestion === OwnMoneyQuestion.OWN_MONEY_BUTTON && !this.store.isSummary) ||
            (this.store.isActiveQuestion(OwnMoneyQuestion.OWN_MONEY_BUTTON) && this.store.isSummary)
        );
    }
    showOwnMoneyAmount(): boolean {
        return (
            (this.activeQuestion === OwnMoneyQuestion.OWN_MONEY_AMOUNT_INPUT && !this.store.isSummary) ||
            (this.store.isActiveQuestion(OwnMoneyQuestion.OWN_MONEY_AMOUNT_INPUT) && this.store.isSummary)
        );
    }
}
